import { Component, Input, OnInit, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';
import { IconService } from './icon.service';
import { DarkModeService } from '../../services/dark-mode.service';

@Component({
  selector: 'rqa-icon',
  template: '<span [innerHTML]="icon | async"></span>',
  styleUrls: ['./icon.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class IconComponent implements OnInit {
  @Input() iconName: string;
  @Input() height: string;
  @Input() width: string;
  icon: Observable<SafeHtml | null>;

  private iconService = inject(IconService);
  private darkModeService = inject(DarkModeService);

  constructor() {
    effect(() => {
      this.darkModeService.isDarkMode();

      if (this.iconName) {
        this.loadIcon();
      }
    });
  }

  ngOnInit() {
    this.loadIcon();
  }

  private loadIcon() {
    this.icon = this.iconService.loadIcon(this.iconName, this.width, this.height);
  }
}
